<template>
	<div v-if="!isOnline" class="offline-banner">
		<div class="alert alert-warning my-0 text-center" role="alert">
			<i class="bi bi-wifi-off me-2"></i>
			You are currently offline. Some features may be unavailable.
		</div>
	</div>
</template>

<script setup>
	import { isOnline } from "../utils/networkBus"
</script>

<style scoped>
	.alert {
		top: 0;
	}
	.offline-banner {
		position: sticky;
		top: 0;
		z-index: 1000;
	}
</style>
